export default __webpack_public_path__ + "static/media/treasure-box.4e73d312.svg";